export const Role = {
  Ubisell: 'ubisell',
  Admin: 'administrator',
  User: 'user',
  Reseller: 'reseller'
}
